import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';
import { SERVICE_PHRASE } from '../constants/constants';
import { Observable, of } from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import { LoggedInUserDetailsService } from './logged-in-user-details.service';
import { BaseHttpService } from './base-http.service';

declare var selfServiceValues: any;

@Injectable({
  providedIn: 'root'
})
export class RealmsDetailsService {

  private _realmsDetails: any;

  constructor(private http: HttpClient,
              private baseHttp: BaseHttpService,
              private loggedInUserDetailsService: LoggedInUserDetailsService) { }

  get realmsDetails(): any {
    return this._realmsDetails;
  }

  getRealmsDetails(selfService?: boolean) {
    if (this._realmsDetails) {
      return of(this._realmsDetails);
    } else {
      return this.fetchRealmsDetails(selfService);
    }
  }

  fetchRealmsDetails(selfService?: boolean): Observable<any> {
    let url = selfService ? environment.urls.getSelfRealmsDetails : environment.urls.getRealmsDetails;
    const reqHeaders = new HttpHeaders({
      Authorization: 'Bearer ' + selfServiceValues.serviceValue(SERVICE_PHRASE, url, null, this.loggedInUserDetailsService.calculatedOffset)
    });

    return this.http.get(url, { headers: reqHeaders }).pipe(map((response: any) => {
      response = selfServiceValues.extractJSON(SERVICE_PHRASE, response.result);
      let realmsData = null;
      if (response && !response.error) {
        realmsData = this.formatRealmsData(response);
      }
      this._realmsDetails = realmsData;

      return response;
    }), catchError(err => { return of(null) }));
  }

  private formatRealmsData(realmsInfo) {
    let realmsData = {};
    for (let index = 0; index < realmsInfo.length; index++) {
      const realmEntity = realmsInfo[index];
      if (realmEntity.name && realmEntity.resources && realmEntity.name.indexOf("/") > -1) continue;
      realmsData[realmEntity.name] = realmEntity.resources;
    }

    return realmsData;
  }
}
